<!-- 图书柜-弹窗对话框 -->
<template>
  <div class="BookcaseDialog" v-show="visible">
    <div class="dialog-body">
      <slot name="body">弹窗内容</slot>
      <!-- <p class="text">该商品已别其他人预定 请归还到原来的位置</p>
      <p class="bbtn-yes">好的</p> -->
    </div>
  </div>
</template>

<script>
  import { storage } from '../../../../static/js/utils/utility'
  let vm, timer

  export default {
    name:'BookcaseDialog',
    components: {
    },
    computed: {
    },
    props: {
      visible: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
      }
    },
    created() {
      vm = this
    },
    mounted () {
      // console.log('this', this.$route)
    },
    methods: {
    },
    watch: {
    },
  }
</script>

<style lang="less">
.Bookcase{
  .BookcaseDialog {
    width: 100%;
    height: calc(100vh - 4rem);
    background-color: rgba(0, 0, 0, 0.45);
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 20;
    .dialog-body {
      width: 6.88rem;
      height: 4.14rem;
      margin: 4.25rem auto 0;
      text-align: center;
      background-color: #ffffff;
      display: flex;
      flex-direction: column;
      align-items: center;
      // justify-content: center;
      position: relative;
      .text {
        margin-top: 1.2rem;
        max-width: 4.6rem;
        font-size: 0.4rem;
        line-height: 0.6rem;
        font-weight: bold;
        color: #333333;
      }
      .bbtn-yes {
        width: 2.63rem;
        height: 0.73rem;
        line-height: 0.73rem;
        margin-top: 0.84rem;
        font-size: 0.4rem;
        color: #ffffff;
        border-radius: 0.05rem;
        background-color: #647de6;
      }
      .dialog-footer {
        width: 100%;
        height: 1.02rem;
        line-height: 1.02rem;
        border-top: 1px solid #c7c7cc;
        display: flex;
        position: absolute;
        left: 0;
        bottom: 0;
        .footer-btn {
          flex: 1;
          font-size: 0.4rem;
          color: #666666;
          text-align: center;
          &:last-child{
            color: #647de6;
            border-left: 1px solid #c7c7cc;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Bookcase/Common/Dialog.vue